import {
  ORDERS_FETCH_SUCCESS,
  GET_ORDER_SUCCESS,
  ORDER_LOADING,
  SET_ORDER_STATUS_DRAFT
} from '../constant/actionType';

const initialState = {
  isLoaded: false,
  orderStatusDraft: '',
  orders: [],
  selectedOrder: {}
};

const ordersReducer = (state = initialState, action) => {
  switch (action.type) {
    case ORDERS_FETCH_SUCCESS:
      return {
        ...state,
        orders: action.data
      };
    case GET_ORDER_SUCCESS:
      return {
        ...state,
        isLoaded: true,
        orderStatusDraft: action.data.status,
        selectedOrder: action.data
      };
    case ORDER_LOADING:
      return {
        ...state,
        isLoaded: false
      };
    case SET_ORDER_STATUS_DRAFT:
      return {
        ...state,
        orderStatusDraft: action.data
      };
    default:
      return state;
  }
};

export default ordersReducer;
